import React, { useEffect } from "react";
import useGatherDataFromApi from "Global/Hooks/useGatherDataFromApi";
import { GetMessageList } from "../Adapter/GetMessageList";

const useStateBank = () => {
  const [data, setData] = React.useState([]);
  // const ArrayOfFunctions = [
  //   {
  //     functions: GetMessageList,
  //     parameters: "MessageList",
  //   },
  // ];
  // const { gatheredData } = useGatherDataFromApi(ArrayOfFunctions);
  // React.useEffect(() => {
  //   if (gatheredData) setData(gatheredData);
  // }, [gatheredData]);

  // useEffect(() => {
  //   GetMessageList(setData, "MessageList");
  // }, [setData]);
  return data;
};

export default useStateBank;
